export default __webpack_public_path__ + "static/media/ai_book_selector_logo.a4539110.jpg";